<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Pfdcyo/tc-custom/9781454926221.jpg?1737234815226" alt="This image is the cover for the book Computer Book, Union Square & Co. Milestones"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Computer Book, Union Square & Co. Milestones
      </h1>
      <p class="bookDescription body article font2">
        <b>An illustrated journey through 250 milestones in computer science, from the ancient abacus to Boolean algebra, GPS, and social media.</b><br/><br/> <br/><br/>With 250 illustrated landmark inventions, publications, and events—encompassing everything from ancient record-keeping devices to the latest computing technologies—<i>The Computer Book</i> takes a chronological journey through the history and future of computer science. Two expert authors, with decades of experience working in computer research and innovation, explore topics including:<br/><br/>the Sumerian abacus * the first spam message * Morse code * cryptography * early computers * Isaac Asimov’s laws of robotics * UNIX and early programming languages * movies * video games * mainframes * minis and micros * hacking * virtual reality * and more<br/><br/>“What a delight! A fast trip through the computing landscape in the company of friendly tour guides who know the history.” —Harry Lewis, Gordon McKay Professor of Computer Science, Harvard University
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Simson L Garfinkel, Rachel H. Grunspan
      </h2>
      
      <p class="authorDescription body article">Simson L. Garfinkel is the Senior Computer Scientist for Confidentiality and Disclosure Avoidance at the US Census Bureau. He holds seven patents and has published dozens of articles on computer security and digital forensics. He is an ACM Fellow, award-winning journalist, and author or coauthor of 15 other books, mostly on computing. Rachel H. Grunspan has worn many hats in her almost 20 years at the CIA including cyber-threat analyst, game and simulation designer, and a leader in the world of digital innovation. She is a member of the Senior Intelligence Service and a winner of the 2007 Director of National Intelligence Galileo Award. Rachel received a BA in Politics from Brandeis University and a Master of Science in Information Systems from the London School of Economics and Political Science.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?15cf070a